<template>
  <QCircularProgress
    v-bind="$attrs"
    v-on="$listeners"
    indeterminate
    :size="size"
    :thickness="thickness"
    :color="color"
    :track-color="trackColor"
    class="sai-spinner"
  />
</template>

<script>
import { QCircularProgress } from 'quasar';

export default {
  name: 'SAISpinner',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    trackColor: {
      default: 'grey-3'
    },
    size: {
      type: String,
      default: 'lg'
    },
    thickness: {
      type: Number,
      default: 0.3
    }
  },
  components: { QCircularProgress }
};
</script>

<style lang="sass" scoped>
.sai-spinner::v-deep circle
  color: $grey-5
</style>
